import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Programs } from "@/components/Programs";
import { Gallery } from "@/components/Gallery";
import { Registration } from "@/components/Registration";
import { Donate } from "@/components/Donate";
import { Contact, Footer } from "@/components/Contact";
import { PaymentSuccess, PaymentCancel } from "@/components/Payment";
import { AdminImpact } from "@/components/AdminImpact";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Landing = () => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/config`);
        setConfig(res.data);
      } catch (e) {
        console.error("Could not load site config", e);
      }
    };
    load();
  }, []);

  const scrollToDonate = () => {
    const el = document.getElementById("donate");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="grain relative">
      <Header onDonate={scrollToDonate} />
      <main>
        <Hero onDonate={scrollToDonate} />
        <About />
        <Programs />
        <Gallery />
        <Registration />
        <Donate />
        <Contact config={config} />
      </main>
      <Footer config={config} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#111111",
            border: "1px solid rgba(196, 245, 66, 0.4)",
            color: "#fff",
            borderRadius: 0,
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin/impact" element={<AdminImpact />}  />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
